<script setup>
const year = new Date().getFullYear()
const config = useRuntimeConfig()
</script>
<template>
    <v-footer class="bg-blue-grey-darken-3 d-flex justify-center">
        <v-container class="footer-wrapper ma-0 pa-0 dynamic-max-width">
            <v-row class="ma-0 pa-0">
                <v-col cols="12" md="4" align="start">
                    <div>
                        <img
                            class="mx-auto mx-md-0"
                            src="https://cdn.visuado.com/visuado-logo-white-horizontal.png"
                            width="100px"
                            height="auto"
                        />
                    </div>
                </v-col>
                <v-col cols="12" md="4" align="center">
                    <div class="mt-2 text-body-2 copyright">
                        Copyright &copy; {{ year }} Visuado AS. All rights reserved.
                    </div>
                </v-col>
                <v-col cols="12" md="4" align="end" class="text-center text-md-right">
                    <v-btn
                        variant="text"
                        class="text-body-2 text-white text-decoration-none"
                        href="/privacy-policy"
                    >
                        {{ $t('privacyPolicy') }}
                    </v-btn>
                    <v-btn
                        variant="text"
                        class="text-body-2 text-white text-decoration-none"
                        href="/cookie-policy"
                    >
                        {{ $t('cookies') }}
                    </v-btn>
                    <slot></slot>
                </v-col>
            </v-row>
        </v-container>
        <div class="app-version">version {{ config.public.appVersion || 'n/a' }}</div>
    </v-footer>
</template>
<style scoped>
.footer-wrapper {
    width: 100%;
}
.app-version {
    position: absolute;
    bottom: 0;
    right: 2px;
    color: white;
    font-size: 10px;
}
</style>
